import React, {Component} from 'react'
import PropTypes from 'prop-types'
import JobTableRow from "./JobTableRow"

class JobTableBody extends Component {
    render() {
        const {listJob, getListingJob, limit, page} = this.props

        return (
            <tbody>
            {
                listJob.length > 0 ? listJob.map((item, index) => {
                        return (
                            <JobTableRow
                                key={item._id}
                                index={index}
                                item={item}
                                limit={limit}
                                page={page}
                                getListingJob={getListingJob}
                            />
                        )
                    })
                    : <tr>
                        <td colSpan={6}>Không có dữ liệu</td>
                    </tr>
            }
            </tbody>
        )
    }
}

JobTableBody.propTypes = {
    limit: PropTypes.number,
    page: PropTypes.number,
    getListingJob: PropTypes.func,
    listJob: PropTypes.array.isRequired
}

export default JobTableBody